import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { Card, Tabs, Button, Modal } from "antd";
import { TableComp } from "sz-react-utils";
import Request, {API_URL, LAPI_URL} from "../../../request";

const TabPane = Tabs.TabPane


class CampaignHistory extends React.Component {
    state={
        activeKey:'0',
        whatsappTotal:0,
        modalOpen:false,
        record:{},
        emailTotal:{}
    }

    componentDidMount() {

    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    showDetails = (record) =>{
        this.setState({modalOpen:true, record:record})
    }


    handleOk = () => {
        this.setState({modalOpen:false, record:null})
      };
      handleCancel = () => {
          this.setState({modalOpen:false, record:null})
      };

    onChange = activeKey => {
        this.setState({activeKey})
    }

    apiWhatsappRequest = (params) =>{
        return new Promise(async(resolve)=>{
            let response = await Request.getAllWhastappCampaigns(params);
            this.setState({whatsappTotal:response.total})
            resolve(response)
        })
    }

    apiEmailRequest = (params)=>{
        return new Promise(async(resolve)=>{
            let response = await Request.getAllEmailCampaigns(params)
            console.log(response)
            this.setState({emailTotal:response.total})
            resolve(response);
        })
    }

    render() {
        let {modalOpen, record} = this.state;
        const emailColumns = [
            {
                title:'Sr.No',
                key:'serialNumber',
                width:80,
                render:(text,record,index)=>(
                    <span>{index+1}</span>
                )
            },
            {
                title:'Campaign Name',
                key:'campaignName'
            },
            {
                title:'Email Type',
                key:'emailType'
            },
            {
                title:'To Email',
                key:'toEmail',
                render:(text,record)=>{
                    let fieldArray = {
                        "active":`Bulk Email To Active ${record.emailType}`,
                        "custom":"Custom - Email to Any Recipient",
                        "all":`Bulk Email To All ${record.emailType}`,
                        'excel':`Excel Data - Bulk Email to New ${record.emailType}`
                    }
                    return (
                        <span>{fieldArray[record.toEmail]}</span>
                    )
                }
            },
            {
                title:'CSV File',
                key:'emailFile',
                render:(text,record)=>{
                    if(record.emailFile && record.emailFile.length>0) {
                        return (
                            <Button type="primary" target="_blank" href={`${LAPI_URL}/${record.emailFile[0].url}`}>Download File</Button>
                        )
                    }
                }
            },
            {
                title:'Email Ids',
                key:'emailIds',
                render:(text,record)=>{
                    if(record.emailIds && record.emailIds.length>0) {
                        return (
                            <Button type="primary" onClick={()=>this.showDetails(record)}>View Details</Button>
                        )
                    }
                }
            }
        ]
        const whatsappColumns = [
            {
                title:'S.No',
                key:'serialNumber',
                width:80,
                render:(text,record, index) =>(
                    <span>{index+1}</span>
                )
            },
            {
                title:'Campaign Name',
                key:'campaignName'
            },
            {
                title:'Whatsapp Type',
                key:'whatsappType'
            },
            {
                title:'To Whatsapp',
                key:'toWhatsapp',
                render:(text,record)=>{
                    let fieldArray = {
                        "active":`Bulk Whatsapp To Active ${record.whatsappType}`,
                        "custom":"Custom - Whatsapp to Any Recipient",
                        "all":`Bulk Whatsapp To All ${record.whatsappType}`,
                        'excel':`Excel Data - Bulk Whatsapp to New ${record.whatsappType}`
                    }
                    return (
                        <span>{fieldArray[record.toWhatsapp]}</span>
                    )
                }
            },
            {
                title:'CSV File',
                key:'whatsappFile',
                render:(text,record)=>{
                    if(record.whatsappFile && record.whatsappFile.length>0) {
                        return (
                            <Button type="primary" target="_blank" href={`${LAPI_URL}/${record.whatsappFile[0].url}`}>Download File</Button>
                        )
                    }
                }
            },
            {
                title:'Whatsapp Numbers',
                key:'whatsappNumbers',
                render:(text,record)=>{
                    if(record.whatsappNumbers && record.whatsappNumbers.length>0) {
                        return (
                            <Button type="primary" onClick={()=>this.showDetails(record)}>View Details</Button>
                        )
                    }
                }
            }
        ];
        return (
            <PageHeaderWrapper title={`Campaign History`}>
                {
                    modalOpen?
                    <Modal title={`Campaign Name : ${record.campaignName}`} visible={modalOpen} onOk={this.handleOk} onCancel={this.handleCancel} footer={[
                        <Button type='primary'>Created By :- {record.createdByUser.name}</Button>
                    ]}>
                        {
                            record.whatsappNumbers && record.whatsappNumbers.length>0?<p>{record.whatsappNumbers.join(' || ')}</p>:<p>{record.emailIds.join(' || ')}</p>
                        }
                        
                    </Modal>
                    :null
                }
                <Card bordered={true}>
                    <Tabs activeKey={this.state.activeKey} onChange={this.onChange} type="card">
                        <TabPane tab={"Whatsapp Campaigns"} key={0}>
                        <h2>{`Total : ${this.state.whatsappTotal}`}</h2>
                        <TableComp
                        ref={this.table}
                        columns={whatsappColumns}
                        apiRequest={this.apiWhatsappRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                        </TabPane>
                        <TabPane tab={"Email Campaigns"} key={1}>
                            <h2>{`Total : ${this.state.emailTotal}`}</h2>
                            <TableComp
                        ref={this.table}
                        columns={emailColumns}
                        apiRequest={this.apiEmailRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CampaignHistory)